<template>
  <div>
    <div class="ban-p">
      <img
        v-if="result && result.headerImg"
        :src="imageUrl + result.headerImg"
      />
    </div>
    <div class="g-snva1" v-if="this.$store.state.navlist">
      <div class="wp" v-if="this.$store.state.navlist[4]">
       <div class="cur">
          <router-link to="/" tag="a">{{ $t("homeTxt") }}</router-link>
          &gt; <span>{{ this.$store.state.navlist[4].name}}</span>
        </div>
         <ul class="ul-snv-r" v-if="this.$store.state.navlist[4].sub">
          <li
            :class="[item.url == '/case' ? 'on' : '']"
            v-for="(item, index) in this.$store.state.navlist[4].sub"
            :key="index"
          >
            <template v-if="item.url != '/case' && item.show">
              <a class="v2" href="javascript:;" @click="changeId(item.cid)">{{ item.name }}</a>
            </template>
            <template v-if="item.url == '/case' && item.show">
              <a class="v2" href="javascript:;" >{{ item.name }}</a>
            </template>
          </li>
        </ul>
        
      </div>
    </div>
    <div class="box-pict">
      <div class="wp">
        <div class="tit-hos">{{ $t("case.tit") }}</div>
        <ul class="ul-hospic" v-if="caseRes && caseRes.records">
          <li v-for="(item, index) of caseRes.records" :key="index">
            <!-- @click="toDetail(item.id)" -->
            <div class="con">
              <div class="pic">
                <img :src="imageUrl + item.contentImg" />
              </div>
              <div class="txt">
                <h3>{{ item.contentTitle }}</h3>
                <div class="desc">{{ item.summary }}</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="pages" v-if="total && total > size">
      <ul>
        <li class="prev" :class="[curPage == 1 ? 'hide' : '']">
          <span @click="prevPage">&lt;</span>
        </li>
        <li
          :class="[curPage == index + 1 ? 'on' : '']"
          v-for="(item, index) of pages"
          :key="index"
        >
          <span @click="navToPage(index + 1)">{{ index + 1 }}</span>
        </li>
        <li class="next" :class="[curPage == pages ? 'hide' : '']">
          <span @click="nextPage">&gt;</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import { Loading } from 'element-ui';
import subnav from '@/components/subnav';
export default {
  components: {
    subnav
  },
  data () {
    return {
      loading: true,
      result: null,
      caseRes: {},
      pages: '',
      size: '',
      curPage: '',
      total: '',

      pageInfo: {
        zhId: '1437741715087142914',
        enId: '1437741801162649602'
      }
    }
  },
  /* mounted () {
    let lang = localStorage.getItem("locale") || 'zh';
    this.lang = lang;
    this.$i18n.locale = lang;
  }, */
  created () {
    let that = this;
    Loading.service();
    /* if (that.$i18n.locale === 'zh') {
      that.getCase(that.pageInfo.zhId);
    } else if (that.$i18n.locale === 'en') {
      that.getCase(that.pageInfo.enId);
    } */
    that.getCase(that.pageInfo.enId);
  },
  /* watch: {
    '$i18n.locale' (newValue) {
      Loading.service();
      if (this.$i18n.locale === 'zh') {
        this.getCase(this.pageInfo.zhId);
      } else if (this.$i18n.locale === 'en') {
        this.getCase(this.pageInfo.enId);
      }
    }
  }, */
  methods: {
    changeId (id) {
      let that = this,serid = id;
      that.$store.commit('changeServiceId', serid);
      localStorage.setItem('serId', serid);
      // this.$router.push('service');
      that.$router.push({ name: 'Service', params: { id: serid } })
    },
    // 跳转详情
    toDetail (id) {
      let that = this
      that.$router.push({ name: 'Details', query: { id: id }, params: { bgimg: that.result.headerImg, type: '2' } })
    },
    // 获取案例信息
    getCase (id) {
      let that = this;
      let data = {
        id: id
      };
      that.$http
        .getCase(data)
        .then((res) => {
          if (res.code == 200) {
            let result = res.result;
            that.result = result;
            let dataConfigs = JSON.parse(result.dataConfigs).configs[0];
            that.url = dataConfigs.path
            that.categoryId = dataConfigs.params.categoryId
            that.page = dataConfigs.params.pageNo || 0
            that.getList(that.page);
          }
        })
        .catch((err) => {
          that.$message(
            {
              message: err,
              type: 'error'
            }
          );
        });
    },
    // 获取案例列表
    getList (page) {
      Loading.service();
      let that = this;
      that.$axios.get(that.url, {
        params: {
          "categoryId": that.categoryId,
          "pageNo": page,
          "column": 'orderNumber',
          "order": 'desc',
          'pageSize': 12,
          "status": 2,
          "contentDisplay": 1
        }
      }).then(function (res) {
        if (res.status == 200) {
          that.caseRes = res.data.result
          Loading.service().close();
          that.pages = res.data.result.pages
          that.curPage = res.data.result.current
          that.total = res.data.result.total
          that.size = res.data.result.size
        }
      }).catch(function (error) {
        that.$message(
          {
            message: err,
            type: 'error'
          }
        );
      });
    },

    navToPage (page) {
      let that = this;
      that.curPage = page
      that.getList(page);
    },
    prevPage () {
      let that = this;
      let prevPage = that.curPage - 1;
      that.curPage = prevPage
      if (prevPage < 1) {
        prevPage = 1
        that.curPage = 1
        return false;
      }
      that.getList(prevPage);
    },
    nextPage () {
      let that = this;
      let nextPage = that.curPage + 1;
      that.curPage = nextPage
      if (nextPage > that.pages) {
        nextPage = that.pages
        that.curPage = that.pages
        return false;
      }
      that.getList(nextPage);
    },

  },

}
</script>

<style>
</style>